import { render, staticRenderFns } from "./HelpSuggestions.vue?vue&type=template&id=6af70339&"
import script from "./HelpSuggestions.vue?vue&type=script&lang=js&"
export * from "./HelpSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports